import { render } from "./ApplicationView.vue?vue&type=template&id=2473d24b&scoped=true"
import script from "./ApplicationView.vue?vue&type=script&lang=js"
export * from "./ApplicationView.vue?vue&type=script&lang=js"

import "./ApplicationView.vue?vue&type=style&index=0&id=2473d24b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2473d24b"],['__file',"src/views/ApplicationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2473d24b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2473d24b', __exports__)) {
    api.reload('2473d24b', __exports__)
  }
  
  module.hot.accept("./ApplicationView.vue?vue&type=template&id=2473d24b&scoped=true", () => {
    api.rerender('2473d24b', render)
  })

}


export default __exports__